
import React from "react";

const AdvertiseDownload = ({ downloadSection }) => {
  if (!downloadSection) return null;

  return (
    <div className="advertise-download">
      <div className="container">
        <div className="row align-items-center">
          <div className="col-md-8 col-sm-12">
            <h2>{downloadSection.title}</h2>
          </div>

          <div className="col-md-4 col-sm-12 text-md-end text-sm-start">
            <a
              href={downloadSection.documentUrl}
              className="download-btn"
              download
              target="_blank"
              rel="noopener noreferrer"
            >
              {downloadSection.buttonText}
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AdvertiseDownload;

